import React from 'react';
import { gql } from '@apollo/client';
import { Show } from 'react-admin';
import PositionRateSettingsShow from '../shared/position-rate-settings-show/PositionRateSettingsShow';
import PositionRateSettingsShowActions from '../shared/position-rate-settings-show/PositionRateSettingsShowActions';
import { generatePositionalRateSettingsShowViewQuery } from '../utils/generatePositionalRateSettingsQuery';

const AgencyLocationPositionRateSettingShow = () => (
  <Show actions={<PositionRateSettingsShowActions />}>
    <PositionRateSettingsShow />
  </Show>
);

AgencyLocationPositionRateSettingShow.query = gql(
  generatePositionalRateSettingsShowViewQuery('agency_location_position_rate_setting'),
);

export default AgencyLocationPositionRateSettingShow;
